export enum IsbnIllustrationTypeEnum {
  Chart,
  Map,
  Tables,
  None
}
